import BrandList from './BrandList'

export default BrandList
